import { Collapse } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/pro-regular-svg-icons";

export default function CustomCollapse(props) {
	const {
		className = "",
		defaultActiveKey = ["0"],
		expandIconPosition = "end",
		destroyOnHidden = true,
		items = [],
		...rest
	} = props;

	return (
		<Collapse
			className={className}
			defaultActiveKey={defaultActiveKey}
			expandIconPosition={expandIconPosition}
			destroyOnHidden={destroyOnHidden}
			expandIcon={({ isActive }) =>
				isActive ? (
					<FontAwesomeIcon icon={faAngleUp} />
				) : (
					<FontAwesomeIcon icon={faAngleDown} />
				)
			}
			items={items}
			{...rest}
		/>
	);
}
